import axios from 'axios';

// In production, use relative URL to work with any domain
const API_URL = process.env.NODE_ENV === 'production' 
  ? '/api'
  : (process.env.REACT_APP_API_URL || 'http://localhost:8000/api');

class SettingsService {
  // Get user settings
  async getSettings() {
    try {
      const response = await axios.get(`${API_URL}/settings`, {
        headers: {
          'x-auth-token': localStorage.getItem('token')
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching settings:', error);
      throw error;
    }
  }

  // Update settings
  async updateSettings(settings) {
    try {
      const response = await axios.put(`${API_URL}/settings`, settings, {
        headers: {
          'x-auth-token': localStorage.getItem('token')
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error updating settings:', error);
      throw error;
    }
  }

  // Update notification preferences
  async updateNotifications(notifications) {
    try {
      const response = await axios.put(`${API_URL}/settings/notifications`, notifications, {
        headers: {
          'x-auth-token': localStorage.getItem('token')
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error updating notifications:', error);
      throw error;
    }
  }

  // Update privacy settings
  async updatePrivacy(privacy) {
    try {
      const response = await axios.put(`${API_URL}/settings/privacy`, privacy, {
        headers: {
          'x-auth-token': localStorage.getItem('token')
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error updating privacy:', error);
      throw error;
    }
  }

  // Update preferences
  async updatePreferences(preferences) {
    try {
      const response = await axios.put(`${API_URL}/settings/preferences`, preferences, {
        headers: {
          'x-auth-token': localStorage.getItem('token')
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error updating preferences:', error);
      throw error;
    }
  }
}

export default new SettingsService();